// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607292004/js/" + chunkId + "." + {"44":"774e7da8","225":"532eb2ef","481":"ebfd7c9b","486":"7ae5a213","770":"6cf6741e"}[chunkId] + ".0.38067562019163825.chunk.js";
};